import type { Metadata } from "next";
import { LegalLayout, LegalSection } from "@/components/legal/legal-layout";

export const metadata: Metadata = {
  title: "Chính sách Cookie",
  description: "Tử Vi Số sử dụng cookie như thế nào.",
};

export default function CookiePage() {
  return (
    <LegalLayout
      title="Chính sách Cookie"
      subtitle="Cách Tử Vi Số sử dụng cookie và công nghệ tương tự."
      lastUpdated="30/05/2026"
    >
      <LegalSection title="1. Cookie là gì?">
        <p>
          Cookie là tệp văn bản nhỏ trình duyệt lưu lại để website nhận diện thiết bị, ghi nhớ tuỳ
          chọn và phân tích hành vi.
        </p>
      </LegalSection>

      <LegalSection title="2. Loại cookie chúng tôi dùng">
        <ul className="ml-5 list-disc space-y-1.5">
          <li>
            <strong>Cần thiết (luôn bật):</strong> session login, CSRF token, lựa chọn cookie. Không
            thể tắt vì website không hoạt động được nếu thiếu.
          </li>
          <li>
            <strong>Tuỳ chọn (cần đồng ý):</strong> ghi nhớ form ngày sinh đã nhập gần đây để bạn
            không phải nhập lại.
          </li>
          <li>
            <strong>Phân tích (cần đồng ý):</strong> Google Analytics 4 — đếm lượt truy cập, đo hiệu
            suất, đã ẩn danh IP.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Quản lý cookie">
        <p>
          Bạn có thể chấp nhận / từ chối cookie tuỳ chọn qua banner cookie ở lần truy cập đầu tiên.
          Có thể đổi lựa chọn bất cứ lúc nào bằng cách xoá cookie trên trình duyệt — banner sẽ hiện
          lại.
        </p>
        <p>
          Tắt cookie cần thiết sẽ làm hỏng login và một số tính năng. Tắt cookie phân tích không ảnh
          hưởng đến trải nghiệm.
        </p>
      </LegalSection>

      <LegalSection title="4. Bên thứ ba">
        <p>
          Cookie phân tích đến từ Google (analytics.google.com). Chúng tôi không đặt cookie quảng
          cáo của bên thứ ba.
        </p>
      </LegalSection>

      <LegalSection title="5. Liên hệ">
        <p>
          Câu hỏi về cookie:{" "}
          <a href="mailto:privacy@tuvi-so.example" className="text-brand-gold hover:underline">
            privacy@tuvi-so.example
          </a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
